var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.newCookie)?[_c('client-only',[_c('cookie-alert-v-2',{ref:"cookieAlertV2"})],1)]:[_c('cookie-alert')],_vm._v(" "),(!_vm.hideScrollTop)?_c('scroll-to-top'):_vm._e(),_vm._v(" "),(!_vm.hideCartTrigger)?_c('cart-trigger'):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }